import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux';
import { Input, DatePicker } from 'antd';
import MySegmented from '../../../components/segmented/Segmented.jsx';
import ModalComponent from '../../../components/modals/ModalComponent.jsx';
import TableWithSkeleton from "../../../components/table/TableWithSkeleton.jsx";
import Pagination from "../../../components/pagination/Pagination.jsx"
import columns from "../../../columns/InternalTransfer.js";
import Eye from "../../../assets/Eye.jsx";
import { GetAllInternalTransferApi } from '../../../api/request/transfer';
import { formatDate } from '../../../utils/utils.js';
import { useResponsive } from '../../../hooks/useResponsive.js';

const { RangePicker } = DatePicker;

const TransferRequest = ({ isRefresh, setIsRefresh }) => {
    const { userDetails } = useSelector(state => state.user);
    const { isMobile } = useResponsive();
    const [filter, setFilter] = useState("Pending");
    const [data, setData] = useState([]);
    const [totalRecord, setTotalRecord] = useState(0);
    const [pageSize, setPageSize] = useState(10);
    const [page, setPage] = useState(1);
    const [searchText, setSearchText] = useState('');
    const [search, setSearch] = useState('');
    const [dates, setDates] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [sorter, setSorter] = useState({ SortBy: 'actionDate', SortOrder: '' });
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [transferDetails, setTransferDetails] = useState(null);

    const getFilteredColumns = (statusFilter) => {
        if (statusFilter === 'Pending') {
            return columns.filter((column) => column?.dataIndex !== 'actionDate');
        }
        return columns;
    };

    const getAllInternalTransfer = async () => {
        setIsLoading(true);
        try {
            const params = {
                userId: userDetails?.id,
                PageNumber: page,
                PageSize: pageSize,
                SearchText: searchText,
                FromDate: dates?.length === 2 ? dates[0].format('MM-DD-YYYY') : '',
                ToDate: dates?.length === 2 ? dates[1].format('MM-DD-YYYY') : '',
                FilterText: filter,
                ...sorter
            };

            const { data } = await GetAllInternalTransferApi(params);
            if (data?.success) {
                setData(
                    data?.data?.map((item) => {
                        return {
                            ...item,
                            name: `${item?.firstName} ${item?.lastName}`,
                            amount: `$ ${item?.amount}`,
                            createdDate: formatDate(item?.createdDate) || '--',
                            actionDate: formatDate(item?.actionDate) || '--',
                            actions: (
                                <button
                                    type="button"
                                    onClick={() => {
                                        setTransferDetails(item);
                                        setIsModalOpen(true);
                                    }}
                                >
                                    <Eye />
                                </button>
                            ),
                        };
                    })
                );
                setTotalRecord(data?.totalRecords);
                setIsRefresh(false);
            }
        } catch (error) {
        } finally {
            setIsLoading(false);
        }
    }

    useEffect(() => {
        getAllInternalTransfer();
    }, [page, pageSize, searchText, dates, filter, sorter, isRefresh]);

    const handleSubmitnew = (event) => {
        event.preventDefault();
        getAllInternalTransfer();
    };

    const handleTableChange = (pagination, filters, sorter) => {
        if (sorter?.order) {
            setSorter({ SortBy: sorter?.field, SortOrder: sorter?.order });
        } else {
            setSorter({ SortBy: 'actionDate', SortOrder: '' });
        }
    };

    return (
        <div>
            <div className="block sm:flex flex-wrap justify-between items-center gap-5">
                <MySegmented
                block={isMobile}
                    options={["Pending", "Approved", "Declined"]}
                    value={filter}
                    setValue={(value) => {
                        setFilter(value);
                        setPage(1);
                    }}
                />

                <div className='flex flex-col sm:flex-row sm:items-center gap-3 mt-5 sm:mt-0'>
                    <form autoComplete="off" onSubmit={handleSubmitnew}>
                        <RangePicker className='py-4 sm:py-1.5 rounded-lg w-full sm:w-auto' format='DD-MM-YYYY' onChange={(dates) => setDates(dates)} />
                    </form>

                    <Input
                        size="large"
                        {...(!isMobile && { style: { width: 220 } })}
                        placeholder="Search"
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                        onPressEnter={() => setSearchText(search)}
                        prefix={
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="w-5 h-5">
                                <path fill-rule="evenodd" d="M10.5 3.75a6.75 6.75 0 1 0 0 13.5 6.75 6.75 0 0 0 0-13.5ZM2.25 10.5a8.25 8.25 0 1 1 14.59 5.28l4.69 4.69a.75.75 0 1 1-1.06 1.06l-4.69-4.69A8.25 8.25 0 0 1 2.25 10.5Z" clip-rule="evenodd" />
                            </svg>
                        }
                        suffix={search &&
                            <svg xmlns="http://www.w3.org/2000/svg" onClick={() => { setSearchText(''); setSearch('') }} viewBox="0 0 24 24" fill="#bebebe" className="size-5 cursor-pointer duration-300 hover:fill-[#969595]">
                                <path fill-rule="evenodd" d="M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25Zm-1.72 6.97a.75.75 0 1 0-1.06 1.06L10.94 12l-1.72 1.72a.75.75 0 1 0 1.06 1.06L12 13.06l1.72 1.72a.75.75 0 1 0 1.06-1.06L13.06 12l1.72-1.72a.75.75 0 1 0-1.06-1.06L12 10.94l-1.72-1.72Z" clip-rule="evenodd" />
                            </svg>
                        }
                    />
                </div>
            </div>

            <div className="mt-6">
                <div className="border border-gray-200 rounded-xl">
                    <TableWithSkeleton columns={getFilteredColumns(filter)} data={data} loading={isLoading} onChange={handleTableChange} />
                </div>

                <Pagination total={totalRecord} pageSize={pageSize} setPageSize={setPageSize} page={page} setPage={setPage} />
            </div>

            <ModalComponent isOpen={isModalOpen} setIsOpen={setIsModalOpen} title="InternalTransfer Information" width={1300}>
                <div className='p-5'>
                    <div className='grid lg:grid-cols-4 md:grid-cols-3 sm:grid-cols-2 gap-10'>
                        <div>
                            <p className='text-base font-normal'>Wallet Account No.</p>
                            <p className='text-xl primary font-semibold mt-2'>{transferDetails?.walletAccountNo || "--"}</p>
                        </div>
                        <div>
                            <p className='text-base font-normal'>Wallet Balance</p>
                            <p className='text-xl primary font-semibold mt-2'>$ {transferDetails?.availableWalletBalance}</p>
                        </div>
                        <div>
                            <p className='text-base font-normal'>Account No</p>
                            <p className='text-xl primary font-semibold mt-2'>{transferDetails?.accountNo || "--"}</p>
                        </div>
                        <div>
                            <p className='text-base font-normal'>Amount</p>
                            <p className='text-xl primary font-semibold mt-2'>$ {transferDetails?.amount || "--"}</p>
                        </div>
                        <div>
                            <p className='text-base font-normal'>Status</p>
                            <p className='text-xl primary font-semibold mt-2'>{transferDetails?.status || '--'}</p>
                        </div>
                        <div>
                            <p className='text-base font-normal'>Request Date</p>
                            <p className='text-xl primary font-semibold mt-2'>{formatDate(transferDetails?.createdDate) || "--"}</p>
                        </div>
                        {transferDetails?.status !== "Pending" ? <div>
                            <p className='text-base font-normal'>Action Date</p>
                            <p className='text-xl primary font-semibold mt-2'>{formatDate(transferDetails?.actionDate) || "--"}</p>
                        </div> : ""}
                        <div className='col-span-full'>
                            <p className='text-base font-normal'>Comment</p>
                            <p className='text-xl primary font-semibold mt-2'>{transferDetails?.remarks || "--"}</p>
                        </div>
                    </div>
                </div>
            </ModalComponent>
        </div>
    )
}

export default TransferRequest